module.exports = __webpack_public_path__ + "img/T02.240ec430.png";